import { useEffect } from 'react'
import { Route as OriginalRoute } from 'react-router-dom'
import { useDispatch } from 'react-redux';
import { addToDicionarioPaths, resetBreadcrumb, setBreadcrumb, setTituloPagina } from 'painel/actions';
import { verificarPadraoUrl } from 'shared/helper/utilitarioUrl';

const CustomRoute = ({path, title, tituloDinamico, breadcrumbProps, ...rest}) => {

    const dispatch = useDispatch();

    useEffect(() => {
        const { parent = null, enabled = true, skip = false } = breadcrumbProps || {};
        if (!tituloDinamico && !skip) {
            let url = window.location.hash.substring(1).split('?')[0];
            url = verificarPadraoUrl(url, path) ? url : path;
            dispatch(resetBreadcrumb());
            dispatch(setBreadcrumb({ parent, enabled }));
            dispatch(addToDicionarioPaths(url, title));
            dispatch(addToDicionarioPaths(path, title));
            dispatch(setTituloPagina(title));
        }
    }, [path, title]);

    return <OriginalRoute {...rest} />;
};

export default CustomRoute;
